var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "payfly-navs-tab-item" }, [
    _c(
      "a",
      {
        staticClass: "dc-btn dc-btn_size-md",
        class: [
          { "dc-btn_disabled": !_vm.disabledNext },
          _vm.isBackButton ? "dc-btn_secondary" : "dc-btn_primary",
        ],
        attrs: { href: "#" },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.$emit("navigate")
          },
        },
      },
      [_vm._v("\n    " + _vm._s(_vm.buttonText) + "\n  ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }